import { ConvexError } from "convex/values";
import { errorCode, setToken } from "./session";
import { toast } from "./store";

export type CommandResult<T> = { ok: true; value: T } | { ok: false; kind: "signedOut" | "rejected" | "unexpected" };

/** Expected refusals reach the caller as outcomes; cancellation still belongs to its owner. */
export async function command<T>(run: () => Promise<T>, message: string, retry?: () => void): Promise<CommandResult<T>> {
  try { return { ok: true, value: await run() }; }
  catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") throw error;
    if (errorCode(error) === "SIGNED_OUT") { setToken(null); return { ok: false, kind: "signedOut" }; }
    const expected = error instanceof ConvexError;
    if (!expected) console.error("Command failed", error);
    toast(message, retry, retry ? "alert" : undefined, retry ? "Retry" : undefined);
    return { ok: false, kind: expected ? "rejected" : "unexpected" };
  }
}
